module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div role="button" tabindex="0" class="img_holder" ' +
((__t = ( backgroundImage(thumbnail(getPhotoQuality('xl'))) )) == null ? '' : __t) +
' aria-label="' +
((__t = ( I18n.t('photo_item.open_photo', { altText: altText() }) )) == null ? '' : __t) +
'">\n    <img alt="' +
((__t = ( decodeUtf8(altText()) )) == null ? '' : __t) +
'" src="' +
((__t = ( thumbnail(getPhotoQuality('xl')) )) == null ? '' : __t) +
'" data-prod-image="' +
((__t = (getReview().productImage)) == null ? '' : __t) +
'" style="position: fixed; left: -100000px;"/>\n</div>\n\n';
 if (isStory()) { ;
__p += '\n    <i class="story" aria-hidden="true"></i>\n';
 } ;
__p += '\n\n';
 if (isVideo()) { ;
__p += '\n    <div class="layer_video lightboxed" id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'" rel="album" aria-hidden="true">\n        <div class="play_button"></div>\n    </div>\n';
 } ;
__p += '\n\n';
 if (isPartOfCampaign()) { ;
__p += '\n    <button class="vote_button ' +
((__t = ( addClassIfTrue(userVotedSet(), 'active') )) == null ? '' : __t) +
'">\n        ';
 if (gon.display_options.showVoteCount) { ;
__p += '\n            ' +
((__t = ( I18n.t('widget.vote_count', {
                label: userVotedSet() ? I18n.t('widget.voted') : I18n.t('widget.vote'),
                count: like_count
            }) )) == null ? '' : __t) +
'\n        ';
 } else { ;
__p += '\n            ' +
((__t = ( userVotedSet() ? I18n.t('widget.voted') : I18n.t('widget.vote') )) == null ? '' : __t) +
'\n        ';
 } ;
__p += '\n    </button>\n';
 } ;
__p += '\n\n';
 if (gon.display_options.reviewOptions && gon.display_options.reviewOptions.displayReviews && getReview().id !== 0) { ;
__p += '\n    <div class="text_review_holder" data-review-id="' +
((__t = (getReview().id)) == null ? '' : __t) +
'">\n        <p class="product_name">' +
((__t = ( decodeUtf8(getReview().productName) )) == null ? '' : __t) +
'</p>\n        <div class="text_review_content">\n            <p class="screen_reader_only">' +
((__t = ( I18n.t('photo_item.screen_reader_only.review', { productName: getReview().productName }) )) == null ? '' : __t) +
'</p>\n            <div role="img" class="star_holder star_' +
((__t = ( getReview().score )) == null ? '' : __t) +
'" data-score="' +
((__t = ( getReview().score )) == null ? '' : __t) +
'">' +
((__t = ( I18n.t('photo_item.review.star_rating', { reviewScore: getReview().score }) )) == null ? '' : __t) +
'</div>\n            <p class="text_review" data-title="' +
((__t = ( getReview().title )) == null ? '' : __t) +
'">\n                ' +
((__t = ( getReview().content )) == null ? '' : __t) +
'\n            </p>\n        </div>\n        <p class="reviewer_name">' +
((__t = ( getReview().user_name )) == null ? '' : __t) +
'</p>\n        ';
 if (getReview().incentivized) { ;
__p += '\n        <p class="review_incentivized">' +
((__t = ( I18n.t('photo_item.incentivized') )) == null ? '' : __t) +
'</p>\n        ';
 } ;
__p += '\n        ';
 if (gon.display_options.showCommunityBadge) { ;
__p += '\n        <i class="review_community_badge" aria-hidden="true"></i>\n        ';
 } ;
__p += '\n    </div>\n';
 } ;
__p += '\n\n<div class="info_holder">\n    <svg viewBox="0 -5 240 51" preserveAspectRatio="none" aria-hidden="true" focusable="false">\n        <path d="M120,0c82.1,0,100.6,39.2,120,39.2c0,0.7,0,3.6,0,6.7c-23.6,0-194.8,0-240,0\n        c0-2.7,0-4.1,0-6.7C14,39.2,37.9,0,120,0z"/>\n    </svg>\n    <div class="social_holder">\n        <div role="button" tabindex="0" class="pixlee_fshare social_button" title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( I18n.t('photo_item.social.open_window', { social: 'Facebook' }) )) == null ? '' : __t) +
' - ' +
((__t = ( altText() )) == null ? '' : __t) +
'">\n            <i class="fa-brands fa-square-facebook"></i>\n        </div>\n        <div role="button" tabindex="0" class="pixlee_tweet social_button" title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( I18n.t('photo_item.social.open_window', { social: 'Twitter' }) )) == null ? '' : __t) +
' - ' +
((__t = ( altText() )) == null ? '' : __t) +
'">\n            <i class="fa-brands fa-square-x-twitter"></i>\n        </div>\n        <div role="button" tabindex="0" class="pixlee_pinit social_button" title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( I18n.t('photo_item.social.open_window', { social: 'Pinterest' }) )) == null ? '' : __t) +
' - ' +
((__t = ( altText() )) == null ? '' : __t) +
'">\n            <i class="fa-brands fa-square-pinterest"></i>\n        </div>\n        <div role="button" tabindex="0" class="pixlee_tumblr social_button" title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( I18n.t('photo_item.social.open_window', { social: 'Tumblr' }) )) == null ? '' : __t) +
' - ' +
((__t = ( altText() )) == null ? '' : __t) +
'">\n            <i class="fa-brands fa-square-tumblr"></i>\n        </div>\n    </div>\n    <div class="info_content">\n        <div class="users_handle">' +
((__t = ( submitterAnchor(true) )) == null ? '' : __t) +
'</div>\n        ' +
((__t = ( uploaderAdditionalFields() )) == null ? '' : __t) +
'\n        <div class="like_count">' +
((__t = ( native_likes )) == null ? '' : __t) +
'</div>\n        ';
 if (_.isTruthy(getTitle())) { ;
__p += '\n            <div class="users_caption">' +
__e( decode_utf8(getTitle()) ) +
'</div>\n        ';
 } ;
__p += '\n        <div class="users_date">' +
((__t = (  getDate() )) == null ? '' : __t) +
'</div>\n    </div>\n    ';
 if (gon.display_options.showWidgetUserAvatar) { ;
__p += '\n        <div class="user_avatar" ' +
((__t = ( backgroundImage(avatar_url) )) == null ? '' : __t) +
'></div>\n    ';
 } ;
__p += '\n</div>\n\n';
 if (shouldShowProductBadges()) { ;
__p += '\n    <i class="product_badge ' +
((__t = ( getProductBadgeClasses() )) == null ? '' : __t) +
'" aria-hidden="true"></i>\n';
 } else if (!gon.display_options.productBadgeLayout){ ;
__p += '\n    <i class="content_source ' +
((__t = ( contentSourceClass() )) == null ? '' : __t) +
'" aria-hidden="true"></i>\n';
 } ;
__p += '\n\n';
 if (showIncentivizedBadge()) { ;
__p += '\n<p class="incentivized">' +
((__t = ( I18n.t('photo_item.incentivized') )) == null ? '' : __t) +
'</p>\n';
 } ;
__p += '\n\n';
 if (!_.isFalsy(gon.display_options.customCallToActionLink)) { ;
__p += '\n    <a href="' +
((__t = ( decodeURIComponent(gon.display_options.customCallToActionLink) )) == null ? '' : __t) +
'" target="_top" class="custom_call_to_action_anchor" style="font-size:0px">' +
((__t = ( I18n.t('photo_item.cta') )) == null ? '' : __t) +
'</a>\n';
 } ;
__p += '\n';

}
return __p
}